import { render, staticRenderFns } from "./SharingSettings.vue?vue&type=template&id=89e02772&"
import script from "./SharingSettings.vue?vue&type=script&lang=js&"
export * from "./SharingSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports